import { useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import Dialog from '../../organisms/Dialog';
import VehicleForm from './shared/VehicleForm';
import useVehiclePageForm from '../../../hooks/useVehiclePageForm';

interface VehicleListContext {
    refresh: () => void;
}

const VehicleAssetPageForm = () => {
    const navigate = useNavigate();
    const context = useOutletContext<VehicleListContext>();

    const handleClose = () => navigate('/collateral/vehicles');

    const handleSuccess = () => {
        toast.success('Veículo cadastrado com sucesso');
        context?.refresh();
        handleClose();
    };

    const form = useVehiclePageForm({ onClose: handleClose, onCreated: handleSuccess });

    return (
        <Dialog
            id="vehicle-asset-form"
            show={true}
            onClose={handleClose}
            header="Novo Veículo"
            size="lg"
            body={<VehicleForm {...form} />}
            footer={
                <div className="flex gap-2">
                    <button onClick={handleClose} disabled={form.isCreating}
                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 text-sm disabled:opacity-50">
                        Cancelar
                    </button>
                    <button onClick={form.handleCreate} disabled={form.isCreating}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm disabled:opacity-50">
                        {form.isCreating ? 'Salvando...' : 'Cadastrar'}
                    </button>
                </div>
            }
        />
    );
};

export default VehicleAssetPageForm;
